import { PageLoadEvent } from "@faire/retailer-visitor-shared/services/performance/const";
import { PerformanceMarker } from "@faire/retailer-visitor-shared/services/performance/PerformanceMarker";
import { ProductCacheStore } from "@faire/retailer-visitor-shared/stores/domain/ProductCacheStore";
import { ICategoryPageResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/ICategoryPageResults";
import { IProductFirstCatNavRequest } from "@faire/web-api--source/indigofair/data/IProductFirstCatNavRequest";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";

export const fetchProductFirstResults = async (
  request: IProductFirstCatNavRequest,
  user: IUser | undefined,
  { signal }: { signal: AbortSignal | undefined }
): Promise<ICategoryPageResults> => {
  PerformanceMarker.get().mark(PageLoadEvent.primaryFetchStart);
  const response = await ProductCacheStore.get().fetchProductCatNav(
    request,
    user,
    { signal }
  );
  PerformanceMarker.get().mark(PageLoadEvent.primaryFetchEnd);
  return {
    product_tiles: response.product_tiles.map((productTile) => {
      const brand =
        response.brand_by_token[productTile.product?.brand_token ?? ""];
      return {
        ...productTile,
        brand,
      };
    }), // combine brand + product info
    retrieval_queries: response.retrieval_queries,
    request_id: response.request_id,
    visual_filter_options: response.visual_filter_options,
    pagination_data: response.pagination_data,
    filter_sections: response.filter_sections,
    formatted_total_primary_results_count:
      response.formatted_total_primary_results_count,
    brands: [],
    brand_page_query_params: undefined,
    brand_page_query_parameters: undefined,
    related_search_terms: [],
    more_in_c3: undefined,
  };
};
